<p-toast></p-toast>
<div class="grid hidden md:block">
    <div class="col-12">
        <div class="card">
            <h4 class="mt-3 ">{{'GST_DETAILS'| translate}}</h4>
            <div class="card gstDetails">
                <form [formGroup]="gstDeatilsForm" (ngSubmit)="submitUploadGSTDetails()">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-2">
                            <label>{{'FINANCIAL_YEAR'| translate}}
                            </label>
                            <p-dropdown [options]="financialYearList" formControlName="financialYear"
                                placeholder="{{'SELECT_FINANCIAL_YEAR'| translate}}" optionLabel="name"
                                optionValue="value" [ngClass]="{ 'ng-invalid ng-dirty': (isSubmitted  || f.financialYear.touched) && f.financialYear.errors }">
                            </p-dropdown>
                            <div *ngIf="(isSubmitted || f.financialYear.touched) && f.financialYear.errors" class="invalid-feedback">
                                <div *ngIf="f.financialYear.errors.required">{{'FINANCIAL_YEAR_IS_REQUIRED'| translate}}
                                </div>
                            </div>
                        </div>

                        <div class="field col-12 md:col-2">
                            <label>{{'UPLOAD_GST_CERTIFICATE'| translate}}</label>
                            <div class="flex">
                                <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #uploadElement
                                    (uploadHandler)="onUpload($event,'gstCertificatePath', uploadElement)"
                                    name="myfile[]" mode="basic" [maxFileSize]="5000000"
                                    chooseLabel="{{'BROWSE'| translate}}" [auto]="true">
                                </p-fileUpload>
                                <p-image *ngIf="f.gstCertificatePath.value && fileType == 'IMAGE'"
                                    [src]="f.gstCertificatePath.value" alt="Image" width="60"
                                    class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>
                                <div *ngIf="f.gstCertificatePath.value && fileType == 'PDF'" class="flex"
                                    style="margin-top:8px;margin-left: 10px;">
                                    <a style="cursor: pointer;" [href]="f.gstCertificatePath.value"
                                        target="_blank">{{'VIEW_DOC'| translate}}</a>
                                </div>
                            </div>
                            <div *ngIf="(isSubmitted || f.gstCertificatePath.touched) && f.gstCertificatePath.errors" class="invalid-feedback">
                                <div *ngIf="f.gstCertificatePath.errors.required">
                                    {{'GST_CERTIFICATE_IS_REQUIRED'| translate}}
                                </div>
                            </div>
                        </div>

                        <div class="field col-12 md:col-3">
                            <label>{{'Remarks'| translate}}
                            </label>
                            <textarea id="description" formControlName="remarks" placeholder="{{'REMARKS'| translate}}" pInputTextarea required rows="3" cols="20" class="mr-3" [ngClass]="{ 'ng-invalid ng-dirty': (isSubmitted  || f.remarks.touched) && f.remarks.errors }"></textarea>
                            <div *ngIf="(isSubmitted || f.remarks.touched) && f.remarks.errors" class="invalid-feedback">
                                <div *ngIf="f.remarks.errors.required">{{'REMARK_IS_REQUIRED'| translate}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <button pButton pRipple type="submit" label="{{'SAVE'| translate}}" class="p-button-success m-2"></button>
                </form>
            </div>
        </div>
    </div>
</div>